
<template>
  <div>
    <div class="mian" v-for="(item, index) in list" :key="index">
      <!-- 头部 -->
      <!-- <div class="top">
        <img src="../assets/images/头部框.png" alt="" />
        <div class="info">
          <span>质检信息</span>
        </div>
        <div class="num">
          <span>03</span>
        </div>
      </div> -->
      <div class="f-goodsInfo">
        <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div class="goods-title w1">报告名称</div>
            <div class="goodsInfo-text-num texts">
              {{ item.msgItems[item.msgItems.length - 1].op.op.report_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title" style="width: 56px">检测机构</div>
            <div class="goodsInfo-text-num texts">
              {{ item.msgItems[item.msgItems.length - 1].op.op.organ_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title">检测人</div>
            <div class="goodsInfo-text-num texts">
              {{ item.msgItems[item.msgItems.length - 1].op.op.check_username }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div class="goods-title w2">区块链标识</div>
            <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
              {{ item.msgItems[item.msgItems.length - 1].txid }}
            </div>
          </div>
        </div>
      </div>
      <div class="b-material" v-for="(items, index) in listInfo" :key="index">
        <div class="swipe-wrap">
          <img
            :src="items"
            alt=""
            @click="switch_image(items)"
            style="width: 100%; height: 100%"
          />
          <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for="(item, index) in item.msgItems[0].op.op.picurl.split(',')" :key="index" @click="switch_image(item)">
                <img :src="item" alt="" class="img" style="width: 100%; height: 100%;">
              </van-swipe-item>
             
            </van-swipe> -->
        </div>
      </div>
      <!-- <div class="goods-characteristic">
        <div class="goods-characteristic-inner">
          <span @click="toBlockChain(item)">
            区块链标识：{{ item.msgItems[0].txid }}</span
          >
        </div>
      </div> -->
      <div class="check" @click="hClick">
        <div>查看更多</div>
        <div class="icon"></div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import { ImagePreview } from "vant";
import Sertificate from "../components/Sertificate.vue";

Vue.use(Swipe);
Vue.use(Overlay);
Vue.use(SwipeItem);
export default {
  components: { Sertificate },
  props: {
    zjInfo: Object,
  },
  watch: {
    zjInfo(curVal, oldVal) {
      console.log(oldVal, "oldVal");
      if (curVal) {
        this.zjInfo = curVal;
        console.log(this.zjInfo.data_list, "oldVal");

        this.zjInfo.data_list.forEach((item) => {
          item.msgItems.forEach((i) => {
            i.op.op = JSON.parse(i.op.op);
          });
        });
        this.list = this.zjInfo.data_list;

        this.list.forEach((item) => {
          // console.log(item.msgItems[length - 1]);
          this.listPic = item.msgItems[item.msgItems.length - 1];
        });
        this.listInfo = this.listPic.op.op.picurl.split(",").slice(0, 3);
      }
    },
  },
  data() {
    return {
      listData: [],
      list: [],
      list2: [],
      listPic: [],
      listInfo: [],
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {
    // this.listData = JSON.parse(localStorage.getItem("defalutObj"));
    // this.list = this.listData.filter((item) => item.trace_name === "质检信息");
    // console.log("lll", this.list.msgItems);
    // this.list.forEach((item) => {
    //   this.listPic = item.msgItems[0];
    // });
    // this.listInfo = this.listPic.op.op.picurl.split(",").slice(0, 3);
  },
  methods: {
    hClick() {
      this.$router.push({
        path: "/qDetails",
        query: {
          listInfo: this.listPic,
        },
      });
    },
    switch_image(items) {
      ImagePreview([items]);
    },
    toBlockChain(item) {
      this.show = true;
      this.ts = item.msgItems[0].ts;
      this.txid = item.msgItems[0].txid;
      // this.$router.push(
      //   `/Look?ts=${item.msgItems[0].ts}&txid=${item.msgItems[0].txid}`
      // );
    },
  },
};
</script>

<style lang="scss" scoped>
.w1 {
  width: 120px !important;
}
.w2 {
  width: 480px !important;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  .check {
    display: flex;
    width: 100%;
    height: 82px;
    border-top: 1px solid #eaeefb;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 81px;
    color: #00644c;
    opacity: 1;
    align-content: center;
    justify-content: center;
    .icon {
      width: 0px;
      height: 0px;
      margin-top: 30px;
      margin-left: 10px;
      border-left: 18px solid #127855;
      border-top: 9px solid transparent;
      border-bottom: 9px solid transparent;
    }
  }
  position: relative;
  width: 608px;
  margin-bottom: 20px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .product {
    width: 638px;
    height: 828px;
    background-color: skyblue;
    padding: 172px 0 30px 56px;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: -13vw;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
      }
    }
    .picture {
      width: 496px;
      height: 818px;
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 34px 60px 0 50px;
    }
  }
  .f-goodsInfo {
    margin-bottom: 20px;
    .goodsInfo2 {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;

      color: #919ab1;
      opacity: 1;
    }
    .goodsInfo {
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      width: 544px;
      // height: 218px;
      border: 2px solid #f3f3f3;
      opacity: 1;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 36px;
      padding-bottom: 30px;
      padding-right: 30px;
      .goodsInfo-text-num {
        white-space: pre-line;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .texts {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        margin-left: 60px;
        color: #000000;
        opacity: 1;
      }
      .goodsInfo-text {
        margin-top: 30px;
        display: flex;
        margin-left: 20px;
        .goods-title {
          width: 100px;
        }
      }
    }
  }
  .goods-characteristic {
    padding: 48px 0;
    width: 536px;
    margin: 0 auto;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .b-material {
    margin: 0 auto;
    width: 541px;
    height: 393px;
    padding: 25px 0;
    .swipe-wrap {
      width: 494px;
      height: 352px;

      margin: 0 auto;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .material {
      display: flex;
      justify-content: space-between;
      width: 548px;
      height: 49px;

      align-items: center;
      margin: 0 auto;
      border-bottom: 2px solid #e8e8e8;
      .dian {
        .m-title {
          width: 112px;
          height: 40px;
          font-weight: 400;
          line-height: 0px;
          margin-left: 15px;
          margin-top: 5px;
        }
        width: 12px;
        height: 12px;
        background: #000000;
        border-radius: 50%;
        opacity: 1;
        margin-right: -330px;
        font-size: 28px;
      }
      .date {
        width: 250px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: #919ab1;
        opacity: 1;
      }
    }
  }
}
</style>